import React from 'react';
import { resolveBucketImageSrc } from '../../../../utils/utils';
import classes from '../ContentPromotionPopup.module.css';

const ImageContent = ({ url, title }) => (
    <img src={resolveBucketImageSrc(url)} className={classes.ImageRenderer} alt={title} />
);

export default ImageContent;
